import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FeaturedPosts from "../components/sections/FeaturedPosts";
import CyberCorner from "../components/decor/CyberCorner";
import TerminalMessage from "../components/decor/TerminalMessage";
import "../styles/home-page.css";

const heroImages = [
  "/images/hero-butterfly2.jpg",
  "/images/flower.jpg",
  "/images/joan.png",
  "/images/cyclonopedia.png",

];

const HomePage = () => {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 300);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="home-page">
      <img
        src="/images/toprightbackground.png"
        alt=""
        className="home-top-right-image"
      />
      <TerminalMessage
        lines={[
          "For sure as the valley of death",
          "I open up my wallet",
          "And it's full of blood"
        ]}
      />
      <section className="home-hero">
        <CyberCorner />
        <img
          src={heroImages[imageIndex]}
          alt=""
          className="home-hero__image"
        />
        <div className="home-hero__copy">
          <span className="home-hero__eyebrow">Essays / Notes / Projects</span>
          <h1>It is easier to imagine the end of the world than the end of Capitalism.</h1>
          <p>
            <b>
              "That which dies shall still know life in death, for all that decays is not forgotten and reanimated it shall walk the world in a bliss of not-knowing."
            </b>
          </p>
          <p>
            <b>
            - Jeff VanderMeer, Annihilation
            </b>
          </p>
          <div className="home-hero__actions">
            <Link to="/map" className="button-primary">
              Enter Library
            </Link>
            <Link to="/category/esotericism" className="button-secondary">
              Browse Categories
            </Link>
          </div>
        </div>
      </section>

      <FeaturedPosts />
    </div>
  );
};

export default HomePage;